import request from '@/utils/request'

export function createLandingPage(data) {
  return request({
    url: '/marketing_assets/yuebao_commons',
    method: 'post',
    data
  })
}

export function getLandingPageList(params = {}) {
  return request({
    url: '/marketing_assets/yuebao_commons',
    method: 'get',
    params
  })
}

export function modifyLandingPage(data = {}, id = null) {
  return request({
    url: `/marketing_assets/yuebao_commons/${id}`,
    method: 'PUT',
    data
  })
}

export function deleteLandingPage(id) {
  return request({
    url: `/marketing_assets/yuebao_commons/${id}`,
    method: 'DELETE'
  })
}

export function getLandingPageList1(params = {}) {
  return request({
    url: `/marketing_assets/yuebao_pages`,
    method: 'get',
    params
  })
}

export function createLandingPage1(data) {
  return request({
    url: `/marketing_assets/yuebao_pages`,
    method: 'POST',
    data
  })
}

export function treasureNovels(params = {}) {
  return request({
    url: `/marketing_assets/yuebao_page_novel`,
    method: 'GET',
    params
  })
}

export function deleteLandingPage1(data, id) {
  return request({
    url: `/marketing_assets/yuebao_pages/${id}`,
    method: 'DELETE',
    data
  })
}

export function copyLandingPage(data) {
  return request({
    url: `/marketing_assets/yuebao_page_copy`,
    method: 'POST',
    data
  })
}

export function previewLandingPage(params = {}) {
  return request({
    url: `/marketing_assets/yuebao_page_preview`,
    method: 'GET',
    params
  })
}

export function submitForCensorship(data = {}) {
  return request({
    url: `/marketing_assets/yuebao_page_submit`,
    method: 'POST',
    data
  })
}
